export default __webpack_public_path__ + "static/media/twitter.61d903f3.svg";